import { render, staticRenderFns } from "./unpermitted_drawer.vue?vue&type=template&id=bb8cf6c2&"
import script from "./unpermitted_drawer.vue?vue&type=script&lang=js&"
export * from "./unpermitted_drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports